import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from "@cmp-src/primitives/dropdown-menu";
import { cn } from "@gettactic/helpers/src/css/cn";
import React from "react";

interface MenuItemProps {
  onClick: React.MouseEventHandler<HTMLDivElement>;
  text: string;
}

type PopupDirection = "down" | "up";
interface OptionsMenuProps {
  editMenuItems: MenuItemProps[];
  asButton?: boolean;
  popupDirection?: PopupDirection;
  withPortal?: boolean;
  /** Extra classes for the trigger button. */
  triggerClassName?: string;
  /** Extra classes for the trigger icon (merged with the default size). */
  iconClassName?: string;
  /** Extra classes for the dropdown content itself. */
  contentClassName?: string;
}

export const OptionsMenu = ({
  editMenuItems,
  asButton = false,
  popupDirection = "down",
  withPortal = true,
  triggerClassName,
  iconClassName,
  contentClassName
}: OptionsMenuProps) => {
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className={cn(
            "focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2",
            asButton &&
              "rounded border border-highlight/20 bg-white p-3 text-base font-bold text-tertiary hover:bg-neutral-100",
            triggerClassName
          )}
        >
          <div className="flex items-center text-neutral-800 hover:text-neutral-600">
            <span className="sr-only">Open options</span>
            <svg
              className={cn("h-6 w-6", iconClassName)}
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
            </svg>
          </div>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        side={popupDirection === "up" ? "top" : "bottom"}
        withPortal={withPortal}
        className={contentClassName}
      >
        {editMenuItems.map((item: MenuItemProps, index: number) => (
          <DropdownMenuItem
            key={index}
            onSelect={(event) => {
              if (item.onClick) {
                item.onClick(
                  event as unknown as React.MouseEvent<HTMLDivElement>
                );
              }
              event.stopPropagation();
            }}
            className="cursor-pointer"
          >
            {item.text}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
